module.exports = __webpack_public_path__ + "static/img/xiaochengxu.b601200.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/Header/xiaochengxu.png
// module id = 71qf
// module chunks = 32